import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { 
  FETCH_APPOINTMENT_SLOT_URL,
  BOOK_APPOINTMENT_URL,
  TRACK_SR,
  BOOK_APPOINTMENT_URL_ENCRYPT
  
} from '../config/app-settings.config';
import { EncrDecrService } from './encr-decr-service.service';

@Injectable({
  providedIn: 'root'
})
export class SheduleAppointmentService {

  tokenVal = sessionStorage.getItem('jwt');
  s24AccessToken = sessionStorage.getItem("s24_access_token");
  s24TokenExpiryTime = sessionStorage.getItem("s24_expiry_time");

  constructor(private http: HttpClient, private encryptDecService: EncrDecrService) { }

  fetchAppointmentSlot() {
    let httpOptions: any;
    if (this.s24AccessToken && this.s24TokenExpiryTime) {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json",
          "access_token": this.s24AccessToken,
          "expiry_time": this.s24TokenExpiryTime
        }),
        observe: 'response'
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json"
        }),
        observe: 'response'
      };
    }
  
    return this.http.get(`${FETCH_APPOINTMENT_SLOT_URL}`, httpOptions);
  }

  bookAppointment(requestBody){
    let httpOptions: any;
    if (this.s24AccessToken && this.s24TokenExpiryTime) {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json",
          "access_token": this.s24AccessToken,
          "expiry_time": this.s24TokenExpiryTime
        }),
        observe: 'response'
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          Authorization: "Bearer " + this.tokenVal,
          withCredentials: "true",
          "Content-Type": "application/json"
        }),
        observe: 'response'
      };
    }

     requestBody = BOOK_APPOINTMENT_URL_ENCRYPT ? this.encryptDecService.set(requestBody): requestBody;
     return this.http.post(`${BOOK_APPOINTMENT_URL}`, requestBody, httpOptions);
  }

  rescheduleAppointment(){
    const httpOptions ={
      headers: new HttpHeaders({
        Authorization: 'Bearer' + this.tokenVal,
        withCredentials: 'true',
        'Content-Type': 'application/json'
      })
   };     
       return this.http.get(`${TRACK_SR}`, httpOptions);
    // return this.http.get('../assets/mocks/trackAppliacation.json');
  }

}
